//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../../api/common.js'
export default {
    props: ['list','dates'],
    data(){
        return {
            time: this.dates
        }
    },
    created(){
        this.time = common.timestampToTime(this.time);
    }
};



// WEBPACK FOOTER //
// ./src/components/im/imPrescription/index.vue